import React from 'react';
import { Upload, Cpu, CheckCircle } from 'lucide-react';
export function Process() {
  const steps = [{
    id: '01',
    title: 'Input',
    description: 'Grundriss, Fotos oder Skizzen hochladen.',
    icon: Upload
  }, {
    id: '02',
    title: 'KI-Visualisierung',
    description: 'Unser System erstellt hyperrealistische Renderings.',
    icon: Cpu
  }, {
    id: '03',
    title: 'Lieferung',
    description: 'Fertige Visuals in 48h, druckfertig und web-optimiert.',
    icon: CheckCircle
  }];
  return <section id="process" className="py-24 bg-[#0A0A0B]" data-id="element-143">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-144">
        <div className="text-center mb-16" data-id="element-145">
          <h2 className="text-3xl sm:text-4xl font-semibold text-white mb-4" data-id="element-146">
            Der Prozess
          </h2>
          <p className="font-light text-zinc-400" data-id="element-147">
            Von der Skizze zum High-End Rendering in drei einfachen Schritten.
          </p>
        </div>

        <div className="relative" data-id="element-148">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent -z-10 transform -translate-y-1/2" data-id="element-149"></div>

          <div className="grid md:grid-cols-3 gap-12" data-id="element-150">
            {steps.map(step => <div key={step.id} className="relative flex flex-col items-center text-center p-4" data-id="element-151">
                <div className="w-24 h-24 rounded-full glass-card flex items-center justify-center mb-6" data-id="element-152">
                  <step.icon className="w-8 h-8 text-blue-400" data-id="element-153" />
                </div>
                <div className="absolute top-0 right-1/2 translate-x-1/2 -translate-y-4 bg-blue-500 text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-154">
                  {step.id}
                </div>
                <h3 className="text-xl font-medium text-white mb-3" data-id="element-155">
                  {step.title}
                </h3>
                <p className="font-light text-zinc-400 max-w-xs" data-id="element-156">
                  {step.description}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}